import { render, staticRenderFns } from "./PanelTextEditor.vue?vue&type=template&id=4622c044&scoped=true"
import script from "./PanelTextEditor.vue?vue&type=script&lang=js"
export * from "./PanelTextEditor.vue?vue&type=script&lang=js"
import style0 from "./PanelTextEditor.vue?vue&type=style&index=0&id=4622c044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622c044",
  null
  
)

export default component.exports